<!-- NOVO MODAL PARA CONFIGURAÇÃO DE SERVIDOR DE IMPRESSÃO -->
<kendo-dialog [title]="editandoServidor ? 'Editar Servidor de Impressão' : 'Novo Servidor de Impressão'"
              (close)="fecheModal()"
              [minWidth]="600"
              [width]="800">

  <div class="config-servidor-impressao">

    <!-- Seção de Configuração Automática -->
    <div class="config-auto-section" *ngIf="!editandoServidor">
      <p class="text-muted">Configure este computador como servidor de impressão</p>
    </div>

    <!-- Formulário Manual -->
    <div class="form-section">

      <div class="form-row">
        <div class="form-group">
          <label>Nome do Servidor *</label>
          <input type="text"
                 [(ngModel)]="servidorSelecionado.nome"
                 placeholder="Ex: Servidor Principal, Caixa 1"
                 class="form-control">
          <div class="invalid-feedback">
            <p *ngIf="!servidorSelecionado.nome">Obrigatório</p>
          </div>
        </div>
        <div class="form-group">
          <label>Identificação Servidor</label>
          <p class="inputtext">
            <b> {{servidorSelecionado.computadorId}}</b>
          </p>
        </div>
      </div>

      <!-- <div class="form-row">
         <div class="form-group">
           <label>Status</label>
           <div class="checkbox-group">
             <label class="checkbox">
               <input type="checkbox"
                      [(ngModel)]="servidorSelecionado.ativo">
               <div>
                 Servidor ativo
                 <small>Permite que este servidor processe jobs de impressão</small>
               </div>
             </label>
           </div>
         </div>
       </div> -->

      <!-- Seleção de Impressoras -->
      <div class="impressoras-section" *ngIf="!modoCriacaoRapidaServidor">
        <div class="section-header">
          <i class="fe-printer"></i>
          <h5>Impressoras Disponíveis *</h5>
          <small class="text-muted">Selecione as impressoras que estarão disponíveis neste servidor</small>
        </div>

        <div class="alert alert-warning" *ngIf="impressorasDisponiveis.length === 0">
          <i class="fe-alert-triangle"></i>

          <ng-container *ngIf="!qzInstalado">
            <app-qztray-detect (onConectou)="conectouQzTray()"  ></app-qztray-detect>
          </ng-container>
          <ng-container *ngIf="qzInstalado">
            Nenhuma impressora disponível para seleção, se tiver mais impressoras instaladas cadastre no sistema primeiro
          </ng-container>
        </div>

        <div class="impressoras-grid" *ngIf="impressorasDisponiveis.length > 0">
          <div class="impressora-card"
               *ngFor="let impressora of impressorasDisponiveis"
               [class.selected]="impressoraEstaSelecionada(impressora)"
               (click)="toggleImpressoraSelecionada(impressora)">

            <div class="card-header">
              <div class="checkbox-wrapper">
                <input type="checkbox"
                       [checked]="impressoraEstaSelecionada(impressora)"
                       (click)="$event.stopPropagation()"
                       (change)="toggleImpressoraSelecionada(impressora)">
              </div>
              <div class="impressora-info">
                <h6>{{impressora.nome}}</h6>
                <span class="status-badge status-disponivel">Disponível</span>
              </div>
            </div>

            <div class="card-body" *ngIf="impressoraEstaSelecionada(impressora.nome)">
              <div class="detalhes-impressora">
                <div class="detalhe-item" *ngIf="detalhesImpressoras[impressora]">
                  <span class="label">Status:</span>
                  <span class="value">{{detalhesImpressoras[impressora].status || 'Verificando...'}}</span>
                </div>
                <div class="detalhe-item" *ngIf="detalhesImpressoras[impressora]">
                  <span class="label">Localização:</span>
                  <span class="value">{{detalhesImpressoras[impressora].localizacao || 'Local'}}</span>
                </div>
                <div class="detalhe-item" *ngIf="detalhesImpressoras[impressora]">
                  <span class="label">Tipo:</span>
                  <span class="value">{{detalhesImpressoras[impressora].tipo || 'Impressora Local'}}</span>
                </div>
                <div class="detalhe-item" *ngIf="!detalhesImpressoras[impressora]">
                  <button type="button"
                          class="btn btn-sm btn-outline-primary"
                          (click)="$event.stopPropagation(); obtenhaDetalhesImpressora(impressora)">
                    <i class="fe-info"></i> Obter Detalhes
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>

    <div class="alert alert-danger" *ngIf="msgErro">
      {{msgErro}}
    </div>

  </div>

  <kendo-dialog-actions>
    <button type="button"
            class="btn btn-secondary"
            (click)="fecheModal()">
      Cancelar
    </button>

    <ng-container *ngIf="servidorSelecionado.isServidorLocal">
      <button type="button"
              class="btn btn-primary"
              (click)="salvarServidor()"
              [disabled]="salvando ">
        <i class="fe-save"></i>
        Atualizar
      </button>

      <button type="button"
              class="btn btn-danger"
              (click)="removerServidor(this.servidorSelecionado)"
              [disabled]="salvando">
        <i class="fe-trash"></i>
        Remover
      </button>
    </ng-container>

    <ng-container *ngIf="!servidorSelecionado.isServidorLocal && !servidorSelecionado.id">
      <button type="button"
              class="btn btn-primary"
              (click)="salvarServidor()"
              [disabled]="salvando">
        <i class="fe-save"></i>  Salvar
      </button>
    </ng-container>


  </kendo-dialog-actions>
</kendo-dialog>
